import {useLocation, Navigate} from "react-router-dom";
import { useAppSelector } from "../store/hooks";


const Requireauth = ({ children }: { children: JSX.Element })=>{
    const {isLogin} = useAppSelector(state => state.user)
    const location = useLocation()
    if (!isLogin) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    
    return children;
}
export default Requireauth